import { UploadKaroakeDto } from '../../../dto/uploadkaroake/uploadkaroakedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface UploadKaroakeRequest extends APIRequest
{
    getUploadKaroakeRequest(): UploadKaroakeDto;
}

export class UploadKaroakeRequestImpl extends APIRequestDtoImpl implements UploadKaroakeRequest
{
    constructor(private uploadKaroakeData: UploadKaroakeDto)
    {
        super();
    }

    getUploadKaroakeRequest(): UploadKaroakeDto
    {
        return this.uploadKaroakeData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/karoake/uploadkaroake/uploadkaroakerequest.tsx